export const prirmaryVariant = 'BkLogoPrimary';
export const wordmarkVariant = 'BkLogoPrimary';
export const wordmarkVariantCA = 'BkLogoPrimary';
